(() => {
  const initBstProductRecs = (el) => {
    if (!el || typeof Swiper === 'undefined' || window.innerWidth < 768) return;

    const perPage = parseInt(el.dataset.perPage, 10) || 3;
    const wrap = el.closest('.bst-product-recs__slider-wrap') ?? el;

    new Swiper(el, {
      slidesPerView: perPage,
      spaceBetween: 32,
      watchOverflow: true,
      navigation: {
        prevEl: wrap.querySelector('.swiper-button-prev'),
        nextEl: wrap.querySelector('.swiper-button-next'),
      },
    });
  };

  const initAll = () => {
    document.querySelectorAll('.bst-product-recs__slider').forEach(initBstProductRecs);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', ({ target }) => {
    const el = target.querySelector('.bst-product-recs__slider');
    if (el) initBstProductRecs(el);
  });
})();
